import React, { useState } from "react";
import MainLayout1 from "Components/UI/Layout/MainLayout1";
import Typography from "@mui/material/Typography";
import Paper from "Components/UI/Paper";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { Tab, Tabs } from "@mui/material";
import Grid from "@mui/material/Grid";
import { useNavigate } from "react-router-dom";
import { createEndcustomerArticle as createEndcustomerArticleReq } from "API/swesum";
import usePost from "Hooks/usePost";
import EndcustomerArticleFormSystem from "Components/Article/EndcustomerArticleFormSystem";
import EndcustomerArticleFormGeneral from "Components/Article/EndcustomerArticleFormGeneral";
import { usePayRules } from "Context/PayRules";
import { usePopupNotificationContext } from "Context/NotificationPopup";
const initialState = {
  EndCustomerArticleId: "",
  Name: "",
  DebetAccount: "",
  KreditAccount: "",
  VAT: 0,
  Payrule: 0,
  Paytype: 0,
  ParseMessage: "",
  ParseStatus: "",
  SystemStatus: "",
  CreateTime: "",
};

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      style={{
        display: value === index ? "block" : "none",
        minHeight: "400px",
      }}
      id={`x-tabpanel-${index}`}
      aria-labelledby={`x-tab-${index}`}
      {...other}
    >
      {<Box>{children}</Box>}
    </div>
  );
}

export default function CreateEndcustomerArticle() {
  const [formData, setFormData] = useState(initialState);
  const { openError } = usePopupNotificationContext();
  const { payRules, payTypes } = usePayRules();

  const createArticleReq = usePost({
    mtnFunc: (body) => createEndcustomerArticleReq(body),
    onError: () => {
      openError("Ett fel uppstod när artikeln skapades.");
    },
    onSuccess: (data) => {
      navigate(`/endcustomersarticles/${data.Id}`);
      //navigate(`/endcustomersarticles`);
    },
  });

  const handleSave = async () => {
    const errors = [];

    if (!formData.Paytype) {
      errors.push("Betaltyp måste vara ifyllt");
    }

    if (!formData.Payrule) {
      errors.push("Betalningsregel måste vara ifyllt");
    }

    if (errors.length > 0) {
      const errorMessage = errors.join("\n");
      openError(errorMessage);
      return;
    }

    await createArticleReq.post(formData);
  };

  const navigate = useNavigate();

  const handleInputChange = (field, newVal) => {
    setFormData({ ...formData, [field]: newVal });
  };

  const [tabIndex, setTabindex] = useState(0);
  const handleTabSwitch = (event, newValue) => {
    setTabindex(newValue);
  };

  return (
    <>
      <MainLayout1>
        <Paper>
          {" "}
          <Typography sx={{ marginBottom: "2rem" }} variant="h5">
            Skapa slutkundsartikel
          </Typography>
          <Tabs
            value={tabIndex}
            onChange={handleTabSwitch}
            sx={{ marginBottom: "2rem" }}
            variant="scrollable"
            scrollButtons="auto"
          >
            <Tab label="Allmänt" />
            <Tab label="System" />
          </Tabs>
          <TabPanel value={tabIndex} index={0}>
            <EndcustomerArticleFormGeneral
              formData={formData}
              handleInputChange={handleInputChange}
              payRuleOptions={payRules}
              payTypeOptions={payTypes}
            />
          </TabPanel>
          <TabPanel value={tabIndex} index={1}>
            <EndcustomerArticleFormSystem
              formData={formData}
              handleInputChange={handleInputChange}
            />
          </TabPanel>
          <Grid
            item
            xs={12}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            {/* <Stack direction="row" spacing={3}> */}
            <Button onClick={() => navigate(-1)}>Stäng</Button>
            <Button onClick={handleSave} variant="contained" sx={{ ml: 3 }}>
              Spara
            </Button>
            {/* </Stack> */}
          </Grid>
        </Paper>
      </MainLayout1>
    </>
  );
}
